export const DEFAULT_TEST_ID = 'health-plan-summary-card';

export const LOCK_CARD_PURSE_STATUS = {
  LOCK: 'Lock',
  UNLOCK: 'Unlock',
} as const;

export const AMOUNT_NOT_SPECIFIED = 'Amount is not specified';
export const APPLIED_TO_DEDUCTIBLE = ', Applied to deductible';
